const smartSinglesTab = (() => {

  const pageSmartSingles = (document.getElementById("pageSmartSingles") != null);
  if (pageSmartSingles) {



    let secPlan = document.getElementById("jsSecPlan");
    let planWraps = secPlan.querySelectorAll('.js-plan-wrap');

    planWraps.forEach((element, index) => {
      let tabBtn = element.querySelectorAll('.js-tab-btn');
      let tabImg = element.querySelectorAll('.js-tab-img');

      tabBtn.forEach((e, i) => {
        e.addEventListener('click', () => {
          for (let j = 0; j < tabBtn.length; j++) {
            tabBtn[j].classList.remove('act');
            tabImg[j].classList.remove('act');
          }
          tabBtn[i].classList.add('act');
          tabImg[i].classList.add('act');

        });
      });

    });



  }

})();
export default smartSinglesTab;